import React from "react";

import step1Icon from '../../assets/images/icons/process_steps/icon1.svg';
import step2Icon from '../../assets/images/icons/process_steps/icon2.svg';
import step3Icon from '../../assets/images/icons/process_steps/icon3.svg';
import step4Icon from '../../assets/images/icons/process_steps/icon4.svg';
import step5Icon from '../../assets/images/icons/process_steps/icon5.svg';

const steps = [
    {
        title: 'Wybierz samochód',
        desc:  'Przeglądaj oferty i wybierz auto dopasowane do Twoich potrzeb. Filtruj po budżecie, rodzaju finansowania i parametrach pojazdu.',
        icon:  step1Icon,
    },
    {
        title: 'Zarezerwuj i złóż wniosek',
        desc:  'Zarezerwuj wybrane auto i wypełnij prosty wniosek bezpośrednio na stronie. Cały proces zajmuje tylko kilka minut.',
        icon:  step2Icon,
    },
    {
        title: 'Poznaj decyzję leasingową',
        desc:  'Na podstawie Twoich danych przygotowujemy ofertę finansowania. Szybko poznasz decyzję i dostępne warunki leasingu.',
        icon:  step3Icon,
    },
    {
        title: 'Podpisz umowę',
        desc:  'Podpisz umowę leasingową w wygodnej formie – online lub z doradcą. Dbamy o sprawny i przejrzysty proces.',
        icon:  step4Icon,
    },
    {
        title: 'Odbierz samochód',
        desc:  'Odbierz auto i zacznij z niego korzystać. My zajmujemy się formalnościami – Ty skupiasz się na biznesie.',
        icon:  step5Icon,
    },
];

function ProcessSteps({heading, subheading, ctaLabel, onCtaClick}) {
    return (
        <section className="process-steps">
            {heading && (
                <div className="process-steps__heading">
                    <h2 className="process-steps__heading-title">{heading}</h2>
                    {subheading && <p className="process-steps__heading-subtitle">{subheading}</p>}
                </div>
            )}
            <div className="process-steps__inner">
                {steps.map((step, index) => (
                    <React.Fragment key={index}>
                        <div className="process-steps__item">
                            <img src={step.icon} alt="" className="process-steps__icon"/>
                            <h3 className="process-steps__title">{index + 1}. {step.title}</h3>
                            <p className="process-steps__desc">{step.desc}</p>
                        </div>
                        {index < steps.length - 1 && (
                            <div className="process-steps__arrow">›</div>
                        )}
                    </React.Fragment>
                ))}
            </div>
            {onCtaClick && (
                <div className="process-steps__cta-row">
                    <button type="button" className="process-steps__cta-btn" onClick={onCtaClick}>
                        {ctaLabel || 'Złóż wniosek'}
                    </button>
                </div>
            )}
        </section>
    );
}

export default ProcessSteps;
